import { tgxApi } from "../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../helpers/utils/RtkQueryUtils";
import { serialize } from "../../helpers/utils/Utils";

export const nationalOrdersApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        saveNationalOrderResult: build.mutation({
            query: (requestBody) => ({
                url: `/editor/national/save-order-result`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['nationalOrderResultByOrderId', 'getHoaOrderResultByOrderId', 'qcLogicResultList'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Saved", "results");
            },
        }),
        getNationalOrderResultByOrderId: build.query({
            query: (orderId) => {
                return {
                    url: `/editor/get-national-order-result-by-order-id/${orderId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["nationalOrderResultByOrderId"],
            async onQueryStarted(_, {queryFulfilled}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getNationalCertificateOptionsByOrderId: build.query({
            query: (orderId) => ({
                url: `/editor/national-order-result/options/${orderId}`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ["nationalCertificateOptionsByOrderId"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        getNationalSimilarTaxAccountList: build.query({
            query: ({ orderId, propertyIds }) => {
                const param = serialize({ orderId, propertyIds });
                return {
                    url: `/editor/national/get-similar-tax-account-info?${param}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['nationalOrderLogs'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        getNationalPropertyPickerResult: build.mutation({
            query: ({ list, orderPropertyId }) => {
                const paramData = serialize({ orderPropertyId });
                return {
                    url: `/editor/national/property-picker-data?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: list,
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "AccountsLinked");
            },
        }),

        checkNationalTaxOrderResultValid: build.query({
            query: (requestBody) => ({
                url: `/editor/national/validateTaxGeneratePdf`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
        }),

        getNationalLinkedAccounts: build.query({
            query: ({ primaryCollectorId, accountIds }) => {
                const param = serialize({ primaryCollectorId, accountIds });
                return {
                    url: `/editor/national/linkedAccounts?${param}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        addNationalParentAccountsForSubdivision: build.mutation({
            query: ({ subdivisionId, orderResults }) => ({
                url: `/editor/national/add-parent-account/${subdivisionId}`,
                method: 'PUT',
                body: orderResults,
                headers: getAuthorizationHeader(),
            }),
            invalidatesTags: ["nationalOrderResultByOrderId"],
        }),
    }),
});

export const {
    useGetNationalOrderResultByOrderIdQuery,
    useSaveNationalOrderResultMutation,
    useGetNationalCertificateOptionsByOrderIdQuery,
    useLazyGetNationalSimilarTaxAccountListQuery,
    useGetNationalPropertyPickerResultMutation,
    useLazyCheckNationalTaxOrderResultValidQuery,
    useLazyGetNationalLinkedAccountsQuery,
    useAddNationalParentAccountsForSubdivisionMutation,
} = nationalOrdersApi;
